<template>
  <div class="ts-capture">

		<header class="ts-capture_header">
			<div class="ts-capture_header_logo">
    		<img src="~../assets/img/logo.svg" alt="TalentSensus" class="logo_main" />
			</div>
			<div class="ts-capture_header_page-title">
				{{ label }}
			</div>
			<div class="ts-capture_header_exit">
				<a href="/"><img src="~../assets/img/close.svg" alt="Exit" /></a>
			</div>
		</header>

		<div class="ts-progress-bar"><span :style="`width:${currentProgress}%`"></span></div>

		<div class="ts-capture_content">
    	<router-view></router-view>
		</div>
		
  </div>
</template>

<script>
import Vue from 'vue';
export default {
  computed: {
    currentProgress() {
      return this.$route.meta.currentProgress;
		},
		label() {
      return this.$route.meta.label;
    }
  }
};

</script>

<style lang="scss">
  @import '../assets/scss/project/registration.scss';
</style>